import styled from 'styled-components';

export const ParagraphText = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors['Level 5']};
`;
